<div class="relative flex flex-col p-4 pt-2 pb-6">
  <div class="mx-auto mb-5 h-1 w-10 rounded-full bg-gray-200"></div>

  <button type="button"
    class="absolute top-3 right-3 size-10 flex items-center justify-center rounded-full bg-transparent text-gray-400 border-0 p-0 cursor-pointer"
    (click)="dismiss()" aria-label="Close">
    <ion-icon name="close-circle" class="text-[36px]"></ion-icon>
  </button>

  <div class="flex flex-col items-center text-center px-2 pb-5">
    @if (account || avatarUrl) {
    <avatar-round [imageUrl]="avatarUrl" [title]="name" [size]="72"></avatar-round>
    } @else {
    <div
      class="size-[72px] rounded-full flex items-center justify-center border border-solid border-gray-200 bg-gray-50 text-gray-400">
      <ion-icon name="person" class="text-[32px]"></ion-icon>
    </div>
    }
    <p class="m-0 mt-3 text-lg font-semibold text-gray-900 truncate max-w-full">{{ name }}</p>
    @if (contact) {
    <p class="m-0 mt-1 text-sm text-gray-500 truncate max-w-full">{{ contact }}</p>
    } @else if (!account) {
    <p class="m-0 mt-1 text-sm text-gray-400">Not joined yet</p>
    }
  </div>

  @if (canMakeAdmin || canDismissAdmin || canRemove) {
  <div class="flex flex-col divide-y divide-solid divide-gray-100 border-t border-solid border-gray-100">
    @if (canMakeAdmin) {
    <button type="button"
      class="w-full flex flex-row items-center gap-3 px-2 py-3.5 text-left bg-transparent border-0 hover:bg-gray-50 active:bg-gray-100"
      (click)="select('makeAdmin')">
      <ion-icon name="shield-checkmark-outline" class="text-[20px] text-gray-700"></ion-icon>
      <span class="text-sm font-medium text-gray-900">Make admin</span>
    </button>
    }

    @if (canDismissAdmin) {
    <button type="button"
      class="w-full flex flex-row items-center gap-3 px-2 py-3.5 text-left bg-transparent border-0 hover:bg-gray-50 active:bg-gray-100"
      (click)="select('dismissAdmin')">
      <ion-icon name="shield-outline" class="text-[20px] text-gray-700"></ion-icon>
      <span class="text-sm font-medium text-gray-900">Dismiss as admin</span>
    </button>
    }

    @if (canRemove) {
    <button type="button"
      class="w-full flex flex-row items-center gap-3 px-2 py-3.5 text-left bg-transparent border-0 hover:bg-red-50 active:bg-red-50"
      (click)="select('remove')">
      <ion-icon [name]="isSelf ? 'exit-outline' : 'trash-outline'" class="text-[20px] text-red-600"></ion-icon>
      <span class="text-sm font-medium text-red-600">{{ isSelf ? 'Leave group' : 'Remove' }}</span>
    </button>
    }
  </div>
  }
</div>
